import { Card } from "@/components/ui/card";
import { Truck } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Purchases() {
  return (
    <div className="space-y-6" data-testid="purchases-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Purchases</h1>
        <p className="text-sm text-muted-foreground mt-1">Purchase invoices and vendor payments</p>
      </div>
      <Card className="p-16 text-center">
        <Truck size={40} className="mx-auto text-muted-foreground" />
        <div className="mt-4 font-heading font-semibold">Purchase Invoices coming soon</div>
        <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
          Record purchases from suppliers and automatically update inventory. Currently on our roadmap for the next release.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button asChild variant="outline"><Link to="/app/suppliers">Manage Suppliers</Link></Button>
          <Button asChild variant="outline"><Link to="/app/expenses">Track Expenses</Link></Button>
        </div>
      </Card>
    </div>
  );
}
